<template>
  <div>
    <el-alert
      title="请点击下面按钮，在弹出的淘宝链接页面拍下您想要充值的金额，并通知我们的客服人员，我们会为您人工充值，所以在平台的余额会稍后进入您的账户"
      type="info">
    </el-alert>
    <el-button type="primary" style="margin-top:20px;"><a href="https://item.taobao.com/item.htm?spm=a1z10.5-c.w4002-9892165116.67.MD9zv1&id=44420035512" target="_blank" style="color:#fff; text-decoration: none;">充值</a></el-button>
  </div>
</template>
<script>
import { api } from 'src/config'

export default {
  data() {
    return {
      
    }
  },
  methods: {

  },
  components: {
    
  }
}
</script>


// WEBPACK FOOTER //
// recharge.vue?8da71ef2